module.exports = __webpack_public_path__ + "static/assets/029714b5b649f282e64edf39b1d4d396.svg";